import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container about-grid">
        <div className="about-text reveal">
          <h4 className="section-subtitle">Kurumsal</h4>
          <h2 className="section-title">Değişen ve Gelişen Üretim Koşullarına Yenilikçi Çözümler</h2>
          <p>NetTest Testere olarak edindiğimiz tecrübe ve alanlarında uzman mühendis kadromuz ile endüstriyel üretime değer katıyoruz.</p>
          <p>En güncel üretim teknolojileri, mükemmel girdi malzemeleri ve yüksek düzeyde proses kararlılığı, tekrar üretilebilirliğimizi garanti eder. Standartları belirleyen markalarla, üretim maliyetlerinizi kalıcı olarak düşürmek için çalışıyoruz.</p>
          <ul className="about-checkmarks">
            <li><i className="fa-solid fa-check"></i> Uzun Kesme Ömürleri</li>
            <li><i className="fa-solid fa-check"></i> Geniş Uygulama Yelpazesi</li>
            <li><i className="fa-solid fa-check"></i> Yoğun Ar-Ge ve Destek</li>
          </ul>
          <a href="#products" className="btn-outline mt-4">Neden NetTest?</a>
        </div>
        <div className="about-image reveal delay-1">
          <div className="glass-feature">
            <div className="icon">
              <i className="fa-solid fa-gears"></i>
            </div>
            <div>
              <strong>Optimum Performans</strong>
              <span>Kalitede güvenin referansı</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
